var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[(_vm.article.news_content)?_c('content-view-inner',{attrs:{"content":_vm.article.news_content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }